import { render, staticRenderFns } from "./RadioButtonV2.vue?vue&type=template&id=5ba8af65&scoped=true&"
import script from "./RadioButtonV2.vue?vue&type=script&lang=js&"
export * from "./RadioButtonV2.vue?vue&type=script&lang=js&"
import style0 from "./RadioButtonV2.vue?vue&type=style&index=0&id=5ba8af65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba8af65",
  null
  
)

export default component.exports